<template>
    <a-table
            v-if="dataCheck >= 0"
            :columns="columnsBudgetPositionTable"
            :data-source="positionsTable"
            :pagination="false"
    >
        <template slot="namePosition" slot-scope="text, record">
            <div>
                <div v-if="record.edit > 0">
                    <a-input
                            :value="text"
                            @change="(e) => handleChangePosition(e.target.value, record.id, 'namePosition')"
                    ></a-input>
                </div>
                <div v-else>
                    {{text}}
                </div>
            </div>
        </template>
        <template slot="costCenter" slot-scope="text, record">
            <div>
                <div v-if="record.edit > 0">
                    <a-select
                            :disabled="!Boolean(record.costType)"
                            style="width: 160px"
                            show-search
                            :filter-option="filterOption"
                            :value="text"
                            @change="(value) => handleChangePosition(value, record.id, 'costCenter')"
                    >
                        <a-select-option
                                v-for="costCenter in MPKSelector[record.costType]"
                                :value="costCenter"
                                :key="costCenter"
                        >{{ costCenter }}</a-select-option>
                    </a-select>
                </div>
                <div v-else>
                    {{text}}
                </div>
            </div>
        </template>
        <template slot="costType" slot-scope="text, record">
            <div>
                <div v-if="record.edit > 0">
                    <a-select
                            style="width: 160px"
                            show-search
                            :filter-option="filterOption"
                            :value="text"
                            @change="(value) => handleChangePosition(value, record.id, 'costType')"
                    >
                        <a-select-option
                                v-for="(item, key) in MPKSelector"
                                :value="key"
                                :key="key"
                        >{{ key }}</a-select-option
                        >
                    </a-select>
                </div>
                <div v-else>
                    {{text}}
                </div>
            </div>
        </template>
        <template slot="amountNet" slot-scope="text, record">
            <div>
                <div v-if="record.edit > 0">
                    <a-input :value="text"
                             @change="(e) => handleChangePosition(e.target.value,  record.id, 'amountNet')"
                    ></a-input>
                </div>
                <div v-else>
                  {{ roundValue(text) }}
                </div>
            </div>
        </template>
        <template slot="amountConnected" slot-scope="text, record">
            <div v-if="text">
                <a-tag v-if="(record.amountNet - text) >= 0" color="green">
                  {{ roundValue(text) }}
                </a-tag>
                <a-tag v-else color="red">
                  {{ roundValue(text) }}
                </a-tag>
            </div>
        </template>
        <template slot="edit" slot-scope="text, record">
            <div class="editable-row-operations">
                    <span
                            v-if="record.edit > 0"
                            style="display: flex; flex-direction: row">
                        <a
                                :disabled="(record.namePosition == '') || (record.costCenter == null) || (record.costType == null) || (record.amountNet == 0) || !userActiveBudget"
                                @click="() => {savePosition(record)}"
                                style="width: 20px; margin-right: 10px">
                            <a-icon type="save" />
                        </a>
                        <!--                        <a-popconfirm-->
                        <!--                                title="Sure to cancel?"-->
                        <!--                                @confirm="() => {}"-->
                        <!--                                style="width: 20px"-->
                        <!--                        >-->
                        <!--                            <a>-->
                        <!--                                <a-icon type="redo" />-->
                        <!--                            </a>-->
                        <!--                        </a-popconfirm>-->
                    </span>
                <span v-else>
                        <a
                                :disabled="!userActiveBudget"
                                style="margin-right: 10px"
                                @click="() => {changePositionMode(record)}"
                        >
                            <a-icon type="edit" />
                        </a>
                    <a
                            v-if="userActiveBudget"
                            @click="() => {removePositionClick(record)}"
                    >
                            <a-icon style="color: rgb(255, 77, 79)" type="delete" />
                        </a>
                    <a v-else>
                            <a-icon style="color: #c0c0c0" type="delete" />
                        </a>
                    </span>
            </div>
        </template>
        <template slot="footer">
            <div style="display: flex; justify-content: center;">
                <a
                        :disabled="!userActiveBudget"
                        @click="createPosition"
                >
                    <a-icon type="plus" />
                </a>
            </div>
        </template>
    </a-table>

</template>

<script>
    import {
        getPosition,
        addPosition,
        removePosition,
        editPosition
    } from "@/requestFunc";
    import { round10 } from "@/plugins"
    export default {
        name: "positionTable",
        props: ['dataCheck', 'data', 'settings', 'index', 'company', 'userActiveBudget'],
        model: {
            prop: 'dataCheck',
            event: 'downloadPosition'
        },
        computed: {
            costTypes: function () {
                let result = [];
                if (this.settings?.option_get?.CostTypes) {
                    for (let i in this.settings?.option_get?.CostTypes) {
                        result.push({
                            id: i,
                            name: this.settings?.option_get?.CostTypes[i]
                        })
                    }
                }
                return this.settings?.option_get?.CostTypes ? this.settings?.option_get?.CostTypes : []
            },
            costCenters: function () {
                let result = [];
                if (this.settings?.option_get?.MPK) {
                    for (let i in this.settings?.option_get?.MPK) {
                        result.push({
                            id: i,
                            name: this.settings?.option_get?.MPK
                        })
                    }
                }
                return this.settings?.option_get?.MPK ? this.settings?.option_get?.MPK : []
            }
        },
        watch: {
            index() {
                if (this.dataCheck > -1) {
                    this.downloadPositions(this.data.id);
                    this.$emit('downloadPosition', 1);
                }
            }
        },
        data() {
            return {
                columnsBudgetPositionTable: [
                    {
                        title: this.$t("Pozycja"),
                        dataIndex: "namePosition",
                        scopedSlots: { customRender: "namePosition" },
                        width: 150,
                    },
                    {
                        title: this.$t("Centrum kosztu"),
                        dataIndex: "costType",
                        scopedSlots: { customRender: "costType" },
                        width: 150,
                    },
                    {
                        title: this.$t("Typ Kosztu"),
                        dataIndex: "costCenter",
                        scopedSlots: { customRender: "costCenter" },
                        width: 150,
                    },
                    {
                        title: this.$t("Kwota netto"),
                        dataIndex: "amountNet",
                        scopedSlots: { customRender: "amountNet" },
                        width: 150,
                    },
                    {
                        title: this.$t("Kwota podpięta"),
                        dataIndex: "amountConnected",
                        scopedSlots: { customRender: "amountConnected" },
                        width: 150,
                    },
                    {
                        title: this.$t(""),
                        dataIndex: "edit",
                        scopedSlots: { customRender: "edit" },
                        width: 50,
                    },
                ],
                positionsTable: [],
                MPKSelector: []
            }
        },
        methods: {
          roundValue(value) {
            return round10(Number(value), -2);
          },
            createPosition() {
                this.positionsTable.push({
                    edit: 1,
                    id: this.positionsTable.length * -1,
                    namePosition: '',
                    costCenter: null,
                    costType: null,
                    amountNet: 0,
                    amountConnected: 0,
                })
            },
            pushPosition(record) {
                let position = {
                        idBudget: this.data.id,
                        namePosition: record.namePosition,
                        costCenter: record.costCenter,
                        costType: record.costType,
                        amountNet: record.amountNet,
                    };

                addPosition(position).done(() => {
                    this.$emit("updateBudget");
                    record.edit = 0;

                })
                    .fail((e) => {
                        console.err(e);
                        this.$message.error(this.$t("Error loading document"));
                    });

            },
            downloadPositions(id) {
                getPosition(id).done((data) => {
                    this.$message.info(this.$t("Download complete!"));
                    let item = data == "" ? {} : JSON.parse(data);

                    if (Array.isArray(item)) {
                        this.positionsTable = item.map( (el, key) => {
                            return {
                                key,
                                id: el.ID,
                                amountConnected: el.PROPERTY_VALUES.amountConnected,
                                amountNet: el.PROPERTY_VALUES.amountNet,
                                costCenter: el.PROPERTY_VALUES.costCenter,
                                costType: el.PROPERTY_VALUES.costType,
                                idBudget: el.PROPERTY_VALUES.idBudget,
                                namePosition: el.PROPERTY_VALUES.namePosition
                            }
                        })
                    }

                })
                    .fail((e) => {
                        console.err(e);
                        this.$message.error(this.$t("Error loading document"));
                    });
            },
            filterOption(input, option) {
                return (
                    option.componentOptions.children[0].text
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                );
            },
            handleChangePosition(value, idPosition, column) {
                let newData = [...this.positionsTable];
                let target = newData.filter((item) => idPosition === item.id)[0];

                if (target) {
                    target[column] = value;
                    this.positionsTable = newData;
                }


            },
            removePositionClick(record) {
                removePosition(record.id, record.idBudget).done(() => {
                    this.$message.info(this.$t("Remove complete!"));
                    record.edit = 0;
                    this.downloadPositions(this.data.id);
                    this.$emit("updateBudget");

                })
                    .fail((e) => {
                        console.err(e);
                        this.$message.error(this.$t("Error loading document"));
                    });
            },
            changePositionMode(record) {
                record.edit = 2;
                this.positionsTable = [...this.positionsTable];
            },
            changePosition(record) {
                let position = {
                    idBudget: this.data.id,
                    idPosition: record.id,
                    namePosition: record.namePosition,
                    costCenter: record.costCenter,
                    costType: record.costType,
                    amountNet: record.amountNet,
                };

                editPosition(position).done(() => {
                    this.$message.info(this.$t("Change complete!"));
                    record.edit = 0;
                    this.downloadPositions(this.data.id);
                    this.$emit("updateBudget");
                })
                    .fail((e) => {
                        console.err(e);
                        this.$message.error(this.$t("Error loading document"));
                    });
            },
            savePosition(record) {
                if (record.edit == 1) {
                    this.pushPosition(record);
                }
                if (record.edit == 2) {
                    this.changePosition(record)
                }
            },
            createMPKSelector() {

                let result = {};
                if (this.settings.costCenter[this.company]) {
                    result = this.settings.costCenter[this.company].MPK_CostTypes.reduce(
                        (accum, curr) => {
                            for (let mpk of curr.MPK) {
                                if (accum[mpk]) {
                                    accum[mpk].push(...curr.CostTypes);
                                } else {
                                    accum[mpk] = curr.CostTypes;
                                }
                            }
                            return accum;
                        },
                        {}
                    );
                }
                this.MPKSelector = result;
            }
        },
        mounted() {
            if (this.dataCheck > -1) {
                this.downloadPositions(this.data.id);
                this.$emit('downloadPosition', 1);
            }
            this.createMPKSelector();
        }

    }
</script>

<style scoped>

</style>
